module.exports = __webpack_public_path__ + "media/images/frontend/covid19_national_link-58278086936be4ea9a8ebf9477268a58.png";